import React from 'react'
import Navbar from '../Header/Navbar'
import ServicesHero from './ServicesHero/ServicesHero'
import ServiceSet from './ServicesHero/ServiceSet'
import ServiceTrust from './ServicesHero/ServiceTrust'
import Footer from '../Footer/Footer'

function Services() {
    return (
        <div>
           <Navbar/>
           <ServicesHero/>
           <ServiceSet/>
           <ServiceTrust/>
           <Footer/>
        </div>
    )
}

export default Services
